var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCorporateCustomerNetworkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11158_7197",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 40
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H40.5V40H0.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11158_7197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 19.152L36.152 20L33.624 17.472H32.792V18.32L31.944 19.152V20L32.792 20.848V21.68L31.944 23.376H30.264L29.416 21.68L28.584 17.472H27.736L26.888 18.32H26.056L25.208 16.624H22.68L21.848 17.472H18.472V15.792L19.32 14.944H20.152L21 14.112H21.848M21.848 14.112H22.68L24.376 12.416V11.584M21.848 14.112L21 12.416L21.848 9.888L24.376 9.056H26.056V8.208L25.208 6.528L26.056 4.848M25.576 35.344L23.528 34.32L22.68 32.624V31.792L21.848 30.112V29.264L20.152 28.416H17.624L15.944 27.584L15.112 25.056V22.528L16.792 20.848L18.472 20H21L22.68 21.68H23.528L24.376 20.848H26.888V21.68L28.584 25.056L31.112 25.888V26.736L29.416 28.416L28.584 29.264V30.944L26.888 32.624V34.784M31.112 32.4V30.112M17.624 12.416L18.472 11.584L19.32 9.056M15.944 4.848H16.792L17.624 5.68V6.528L15.944 7.376H14.264L13.416 8.208L12.584 9.056V9.888L11.736 10.736L10.056 11.584L8.376 12.416H6.904M5 18.32L6.68 20.848L7.528 21.68V24.208L9.208 26.736L10.888 27.584V28.416L10.056 30.112V31.664M37 20C37 28.837 29.837 36 21 36C12.163 36 5 28.837 5 20C5 11.163 12.163 4 21 4C29.837 4 37 11.163 37 20Z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateCustomerNetworkIcon);
export default __webpack_public_path__ + "static/media/corporateCustomerNetworkIcon.fe327d8be6cfd0e8c4b4c1148c006671.svg";
export { ForwardRef as ReactComponent };